import type { RtlItem } from '../../../config-provider/src/internal-interface'
import rtlStyle from '../src/styles/rtl.cssr'

export const scrollbarRtl: RtlItem = {
  name: 'Scrollbar',
  style: rtlStyle
}

export default scrollbarRtl
